module.exports = __webpack_public_path__ + "img/howto1-en.dbabe378.png";